<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44ZM22.4734 12.2715H25.5222L25.3035 27.4648H22.6921L22.4734 12.2715ZM22.2 32.4414C22.2 33.4395 22.9929 34.2051 23.991 34.2051C25.0164 34.2051 25.7957 33.4395 25.7957 32.4414C25.7957 31.4434 25.0164 30.6777 23.991 30.6777C22.9929 30.6777 22.2 31.4434 22.2 32.4414Z" fill-opacity="0.9"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
